<!-- PopoverSelect：2019-06-05 YuAng-->

<template>
  <el-popover class="popover-filter" :class="group.type" :key="group.type" placement="bottom" v-model="visible" :trigger="trigger"
              :tabindex="100" :popper-class="group.type" :offset="group.offset ? group.offset : 0">
    <ul class="popover-filter-ul">
      <!-- :class="item.id == activeItem.id ? 'active':''" -->
      <template v-for="(item,index) in group.items">
        <li v-if="!item.hide"  class="popover-filter-li" :class="item.active ? 'active': ''"
            :title="item.name"
            @click="clickItem(group.type, item)" :key="'filter-li-' + group.type + index ">
          <i v-if="item.icon" :class="['iconfont', item.icon]"></i>
          <i style="font-style: normal">{{item.name}}</i>
        </li>
      </template>
    </ul>
    <span class="el-dropdown-link" slot="reference" :class="(jump ? 'jump' : visible ? 'active':'')">
      <slot v-if="custom"></slot>
      <template v-else>
        {{group.title}}
        <i class="el-icon--right" :class="visible ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
      </template>
    </span>
  </el-popover>
</template>

<script>
export default {
  name: 'PopoverSelect',
  data () {
    return {
      visible: false,
      activeItem: {value: -1, name: this.group.title, active: true}
    }
  },
  props: {
    group: {
      type: Object,
      default: function () {
        return {
          type: 'select', title: '日期', items: [{id: 0, name: '全部'}, {id: 1, name: '选项一'}]
        }
      }
    },
    fatherAction: {
      type: Function,
      default: null
    },
    custom: { // 自定义
      type: Boolean,
      default: false
    },
    jump: { // 选择后不修改tab标题
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: function () {
        return 'hover'
      }
    }
  },
  mounted () {
    this.setActiveItem()
  },
  methods: {
    clickItem: function (type, item) {
      if (!this.jump) {
        if (item.active === undefined) {
          this.$set(item, 'active', false)
        }
        this.$set(this.activeItem, 'active', false)
        item.active = !item.active
        this.group.title = item.name
        this.activeItem = item
      }
      this.visible = false
      if (this.fatherAction) {
        this.fatherAction({type: type, item: item, $el: this.$el})
      }
    },
    setActiveItem: function () {
      if (this.jump) return
      let items = this.group.items
      if (items && items.length > 0) {
        let item = items.find(function (tab) {
          if (tab.active) {
            return tab
          }
        })
        if (!item) {
          item = items[0]
          if (item.active === undefined) {
            this.$set(item, 'active', true)
          }
        }
        this.group.title = item.name
        this.activeItem = item
      }
    }
  }
}
</script>

<style scoped>
  .popover-filter {
    margin-left: 10px;
    font-size: 13px;
  }

  .popover-filter .el-dropdown-link {
    cursor: pointer;
    font-size: 13px;
    color: #BEBEBE;
    outline:none;
  }

  .popover-filter .el-dropdown-link:hover,.container-top-right .el-dropdown-link.active {
    color: #2695FF;
  }

  .popover-filter-li {
    margin: 0px -11px 4px -11px;
    padding: 5px 10px;
    max-height: 50px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: #999999;
    cursor: pointer;
    text-align: center;
  }
  .popover-filter-li:hover,.popover-filter-li.active {
    background-color: #f5f5f5;
    color:#2695FF ;
  }

  .el-dropdown-link.jump {
    background-color: white;
    color: #BEBEBE !important;
  }

  .popover-filter-li .iconfont {
    font-size: 13px !important;
  }

  .popover-filter-li .iconfont {
    margin-right: 8px;
  }

  .el-icon--right {
    font-style: normal;
  }
</style>
